import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { NavigationItems, SettingsNavigationItems } from "../../App";
import { AuthContext } from "../../context";
import FullPageSkeletonLoader from "../SkeletonLoader/FullPageSkeletonLoader";
import {
  SidebarInset,
  SidebarProvider
} from "@flanksource-ui/components/ui/sidebar";
import { AppSidebar } from "@flanksource-ui/components/Layout/AppSidebar";
import { GuidedTour } from "@flanksource-ui/components/GuidedTour/GuidedTour";
import { TouchpointObserver } from "@flanksource-ui/components/GuidedTour/TouchpointObserver";

interface Props {
  navigation: NavigationItems;
  settingsNav: SettingsNavigationItems;
  checkPath: boolean;
}

export function SidebarLayout({ navigation, settingsNav, checkPath }: Props) {
  const { user } = useContext(AuthContext);

  // Show loading state while user is being fetched
  if (user == null) {
    return <FullPageSkeletonLoader />;
  }

  return (
    <SidebarProvider>
      <GuidedTour />
      <TouchpointObserver />
      <AppSidebar
        navigation={navigation}
        settingsNav={settingsNav}
        checkPath={checkPath}
      />
      <SidebarInset className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-white">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <React.Suspense fallback={<FullPageSkeletonLoader />}>
            <Outlet />
          </React.Suspense>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
